import React from 'react';
import { InstallPwaButton } from '../InstallPwaButton';

interface CrmAuthGateProps {
  requiresAuth: boolean;
  crmRequiresPassword: boolean;
  crmName: string | null;
  authName: string;
  setAuthName: (name: string) => void;
  authInput: string;
  setAuthInput: (pw: string) => void;
  authError: string;
  handleAuthSubmit: (e: React.FormEvent) => void;
  error: string | null;
  hasData: boolean;
}

export function CrmAuthGate({
  requiresAuth,
  crmRequiresPassword,
  crmName,
  authName,
  setAuthName,
  authInput,
  setAuthInput,
  authError,
  handleAuthSubmit,
  error,
  hasData
}: CrmAuthGateProps) {
  if (requiresAuth) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#09090b', color: 'white', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ padding: '2.5rem', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', maxWidth: '400px', width: '100%', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.5)', backdropFilter: 'blur(10px)' }}>
          <h2 style={{ color: 'white', marginTop: 0, paddingBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '1.5rem', fontSize: '1.5rem', letterSpacing: '-0.5px' }}>{crmName || 'CRM Dashboard'}</h2>
          <p style={{ color: '#a1a1aa', fontSize: '0.9rem', marginBottom: '1.5rem' }}>Please enter your Display Name {crmRequiresPassword ? 'and Password' : ''}.</p>
          <form onSubmit={handleAuthSubmit}>
            <input 
              type="text" 
              value={authName}
              onChange={(e) => setAuthName(e.target.value)}
              placeholder="Your Display Name"
              required
              style={{ width: '100%', padding: '0.75rem', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', borderRadius: '4px', marginBottom: '1rem', boxSizing: 'border-box' }}
            />
            {crmRequiresPassword && (
              <input 
                type="password" 
                value={authInput}
                onChange={(e) => setAuthInput(e.target.value)}
                placeholder="Enter Dashboard Password"
                required
                style={{ width: '100%', padding: '0.75rem', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', borderRadius: '4px', marginBottom: '1rem', boxSizing: 'border-box' }}
              />
            )}
            {authError && <div style={{ color: '#ef4444', fontSize: '0.85rem', marginBottom: '1rem' }}>{authError}</div>}
            <button type="submit" style={{ width: '100%', padding: '0.75rem', background: '#38bdf8', color: '#09090b', border: 'none', borderRadius: '4px', fontWeight: 600, cursor: 'pointer' }}>
              Access Dashboard
            </button>
          </form>
          <div style={{ marginTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.5rem' }}>
            <InstallPwaButton isLight={false} />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#09090b', color: 'white', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ padding: '2rem', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '8px', color: '#ff4444' }}>
          <h3>Access Denied</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!hasData) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#09090b', color: '#a1a1aa', fontFamily: 'system-ui, sans-serif' }}>
        <h3>Establishing Secure Connection...</h3>
      </div>
    );
  }

  return null;
}
